import Vue from 'vue'
import App from './App'

import store from '@/store'

import router from './router'

import jssdk from './jssdk/api'
Vue.prototype.$jssdk = jssdk
/*//echarts 组件
import echarts from 'echarts'
Vue.prototype.$echarts = echarts*/

//Element ui 组件
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'
Vue.use(ElementUI)

Vue.config.productionTip = false

//加载本地授权信息
store.commit('loadAuth')

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})




// WEBPACK FOOTER //
// ./src/main.js